import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as BackArrowSvg } from "../../../../assets/backarrow.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { Formik, ErrorMessage } from "formik";
import { InputTemp, SelectTemp } from "../../../../app/common/form/Custom";
import { vendorSchema } from "../../../../app/validation/validationSchema";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import Modal from "../../../../app/common/modals/Custom";
import { ReactComponent as ThumbsUpSvg } from "../../../../assets/navbericon/thumbsup.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Avatar1 } from "../../../../assets/avatar1.svg";
import { ReactComponent as Avatar2 } from "../../../../assets/avatar2.svg";
import { ReactComponent as Avatar3 } from "../../../../assets/avatar3.svg";
import { ReactComponent as Avatar4 } from "../../../../assets/avatar4.svg";
import { ReactComponent as AvatarAlt1 } from "../../../../assets/avataralt1.svg";
import { ReactComponent as AvatarAlt2 } from "../../../../assets/avataralt2.svg";
import { ReactComponent as AvatarAlt3 } from "../../../../assets/avataralt3.svg";
import { ReactComponent as AvatarAlt4 } from "../../../../assets/avataralt4.svg";
import { useStore } from "../../../../app/stores/store";
import Loading from "../../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
import { UserRoleForm } from "../../../../app/models/user";
import responseCodes, { handlePhoneNumber } from "../../../../app/common/hooks/helpers";
import { toast } from "react-toastify";

const NewUser = () => {
  const [modal, setModal] = useState("");
  const navigate = useNavigate();
  const [inputField, setInputField] = useState(new UserRoleForm());
  const { userStore, commonStore } = useStore();
  const { rolesLoading, getVendorRoles, userRoles, registerSubAdmin } =
    userStore;
  const { loggedInUser } = commonStore;

  const saveForm = async () => {
    const payload = { ...inputField, vendorId: loggedInUser!.userId };
    // console.log(payload);

    await registerSubAdmin(payload).then((res) => {
      if (res?.responseCode === responseCodes.response_00) {
        toast.info(res.responseMessage);
        setModal("success");
      }
    });
  };
  const autoGeneratePassword = (length: number) => {
    const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
    const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const digitChars = "0123456789";
    const specialChars = "!@#$%^&*()_+";

    const getRandomChar = (charset: string) => {
      const randomIndex = Math.floor(Math.random() * charset.length);
      return charset.charAt(randomIndex);
    };

    let password = "";

    // Ensure at least one of each character type
    password += getRandomChar(lowercaseChars);
    password += getRandomChar(uppercaseChars);
    password += getRandomChar(digitChars);
    password += getRandomChar(specialChars);

    const remainingLength = length - 4;

    // Fill the remaining password with random characters
    for (let i = 0; i < remainingLength; i++) {
      const charSet =
        lowercaseChars + uppercaseChars + digitChars + specialChars;
      password += getRandomChar(charSet);
    }

    // Shuffle the password to randomize character positions
    let altpassword = password.split("");
    for (let i = password.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [altpassword[i], altpassword[j]] = [altpassword[j], altpassword[i]];
    }
    password = altpassword.join("");

    return password;
  };

  useEffect(() => {
    getVendorRoles();
  }, [getVendorRoles]);
  return (
    <div className={styles.page}>
      {rolesLoading === "loading" && <Loading />}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Add {inputField.name}?</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                // positive
                className={styles.negative}
                onClick={() => setModal("")}
              >
                <div className={styles.button}>
                  <span>Cancel</span>
                </div>
              </Button>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => saveForm()}
              >
                <div className={styles.button}>
                  <span>Yes, I want to!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {modal === "success" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>User Added Successfully</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate("/vendor/users")}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className={styles.back}>
        <BackArrowSvg onClick={() => navigate("/vendor/users")} />
        <span>Go back</span>
      </div>
      <div className={styles.header}>New User</div>
      <Formik
        initialValues={inputField}
        enableReinitialize
        onSubmit={(values) => {
          setInputField(values);
          setModal("open");
        }}
        validationSchema={vendorSchema.subAdmin}
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          isValid,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <div className={styles.column1}>
                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        inputType="text"
                        label={"First Name"}
                        marginRight
                        {...getFieldProps("name")}
                      />
                      <ErrorMessage
                        name={"name"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <InputTemp
                        inputType="text"
                        label={"Last Name"}
                        marginRight
                        {...getFieldProps("lastName")}
                      />
                      <ErrorMessage
                        name={"lastName"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                  </div>
                  
                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        inputType="text"
                        label={"Email"}
                        marginRight
                        {...getFieldProps("email")}
                      />
                      <ErrorMessage
                        name={"email"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <InputTemp
                        inputType="text"
                        label={"Phone Number"}
                        marginRight
                        {...getFieldProps("phoneNumber")}
                        onChange={(e) => handlePhoneNumber(setFieldValue, "phoneNumber", e)} 
                      />
                      <ErrorMessage
                        name={"phoneNumber"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                  </div>

                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        inputType="text"
                        label={"Password"}
                        marginRight
                        {...getFieldProps("password")}
                      />
                      <ErrorMessage
                        name={"password"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <SelectTemp
                        inputType="text"
                        label="Role"
                        options={
                          userRoles &&
                          [...userRoles].map((category, index) => ({
                            key: String(index),
                            label: category.roleName,
                            value: category.vendorRoleId,
                          }))
                        }
                        name="vendorRoleId"
                        onValueChange={(e: any) => {
                          setFieldValue("vendorRoleId", e.value);
                        }}
                        // {...getFieldProps("categoryId")}
                      />
                      <ErrorMessage
                        name={"vendorRoleId"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                  </div>
                  <div className={styles.flexStart}>
                    <div
                      className={styles.sterlinks}
                      onClick={() =>
                        setFieldValue("password", autoGeneratePassword(8))
                      }
                    >
                      Auto-Generate Password
                    </div>
                  </div>
                </div>
                {/* <hr className={styles.hr} /> */}
                <div className={styles.column2}>
                  <label htmlFor="upload" className={styles.uploadlabel}>
                    Priviledges{" "}
                  </label>
                  <div className={styles.flexStart}>
                    <div>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Add Products"
                          onClick={(e) => {
                            setFieldValue("addProducts", !values.addProducts);
                            // setInputField({
                            //   ...values,
                            //   addProducts: !inputField.addProducts,
                            // });
                            // handleChange(!values.addProducts, "addProducts");
                          }}
                        />
                        <FormControlLabel
                          // required
                          control={<Checkbox />}
                          label="View Orders"
                          onClick={(e) => {
                            setFieldValue("viewOrders", !values.viewOrders);
                            // setInputField({
                            //   ...inputField,
                            //   viewOrders: !inputField.viewOrders,
                            // });
                          }}
                        />
                        <FormControlLabel
                          // disabled
                          control={<Checkbox />}
                          label="Shipping"
                          onClick={(e) => {
                            setFieldValue("shipping", !values.shipping);
                            // setInputField({
                            //   ...inputField,
                            //   shipping: !inputField.shipping,
                            // });
                          }}
                        />
                        <FormControlLabel
                          // required
                          control={<Checkbox />}
                          label="Settings"
                          onClick={(e) => {
                            setFieldValue("settings", !values.settings);
                            // setInputField({
                            //   ...values,
                            //   settings: !inputField.settings,
                            // });
                          }}
                        />
                      </FormGroup>
                    </div>
                    <div>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Add Users"
                          onClick={(e) => {
                            setFieldValue("addUsers", !values.addUsers);
                            // setInputField({
                            //   ...inputField,
                            //   addUsers: !inputField.addUsers,
                            // });
                          }}
                        />
                        <FormControlLabel
                          // required
                          control={<Checkbox />}
                          label="Tickets"
                          onClick={(e) => {
                            setFieldValue("tickets", !values.tickets);
                            // setInputField({
                            //   ...inputField,
                            //   tickets: !inputField.tickets,
                            // });
                          }}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <label htmlFor="upload" className={styles.uploadlabel}>
                    Thumbnails{" "}
                  </label>
                  <div className={styles.thumbnails}>
                    {values.vendorRoleId === "1" && <AvatarAlt1 />}
                    {values.vendorRoleId === "2" && <AvatarAlt2 />}
                    {values.vendorRoleId === "3" && <AvatarAlt3 />}
                    {values.vendorRoleId === "4" && <AvatarAlt4 />}
                    {values.vendorRoleId !== "1" && <Avatar1 />}
                    {values.vendorRoleId !== "2" && <Avatar2 />}
                    {values.vendorRoleId !== "3" && <Avatar3 />}
                    {values.vendorRoleId !== "4" && <Avatar4 />}
                  </div>
                </div>
              </div>
              <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  <Button
                    positive
                    className={styles.bulkProduct}
                    disabled={!isValid}
                    type="submit"
                  >
                    <div className={styles.positive}>
                      <span>Save</span>
                    </div>
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(NewUser);
